/* ============================================================
   SNUZONE REVIEWS — Custom Widget v2.1.0 (Konzept A "Urteil", 10/2026)
   Datenquelle: Reviews.io Public API (ohne API-Key, type=product_review)
   Gegenstueck: sections/reviewsio-polaris.liquid v2.1.0

   v2.1.0 (Mehrsprachigkeit, 10/2026):
   - lang=<Shop-Sprache> im API-Request: Reviews.io liefert Reviews
     und Attribute uebersetzt (Feature "Translate reviews", nicht
     offiziell dokumentiert, per Live-Test verifiziert).
   - UI-Texte kommen aus locales/*.json (snuzone_reviews.*) ueber
     das JSON in der Section (data-snzr-i18n).
   - Zahlen + Datum im Format der Shop-Sprache (data-locale).
   - Nikotin-Skala wird ueber einen sprachunabhaengigen Schluessel
     erkannt (attrKey), nicht ueber das deutsche Label.

   v2.0.0 (Neubau nach DS v3.5, Konzept A approved 10/2026):
   - Hero: Score (1 Dezimale) + drei Attribut-Skalen statt
     Verteilung/Attribut-Liste/Sentiment-Tabs.
     * Position = Durchschnitt auf der 1–5-Skala:
       (average_rating - 1) / 4  -> 0–100 %
     * Ergebnis-Wort = Bucket des gerundeten Durchschnitts
       (1–2 / 3 / 4–5 = Reviews.io centered-range-Buckets)
     * Aufsteigende Skalen (Geschmack, Wirkungsdauer): Fuellung
     * Mittig-optimale Skala (Nikotinstaerke): Nadel, keine Fuellung
   - Polarisierungs-Schutz (nur mittig-optimale Attribute, nur wenn
     der Durchschnitt in der Mitte landet): 2 Zaehl-Requests
     (per_page=1, product_question[ID]=1,2 bzw. 4,5 -> results_count),
     Mitte = attribute.count - beide Extreme. Polarisiert, wenn
     Mitte < 50 % UND beide Extreme >= 20 % -> Wort "Uneinheitlich",
     keine Nadel, Anteile unter den Stufen. Plausibilitaetscheck:
     Extreme zusammen > attribute.count = Filter wird von der API
     ignoriert -> kein Polar-Urteil (Wort ohne Nadel).
     Zaehl-Requests haben ein 4-s-Budget, danach Wort ohne Nadel.
   - Verteilung -> Filter-Chips (Alle / 5–1 Sterne mit Anzahl aus
     stats.ratings / Mit Fotos), single-select, Toggle zurueck auf Alle
   - Sortierung: Neueste / Hilfreichste (helpful_desc) / Hoechste /
     Niedrigste. "Mit Fotos" wandert vom Select in die Chips.
   - Review-Suche entfernt (inkl. Langshop-Rebuild-Workaround)
   - Sentiment-Tabs (Metafield) entfernt
   - Card: Sterne + Verifiziert-Badge -> Titel -> Name · Datum ->
     Text -> Attribute inline -> Fotos -> Hilfreich. Ort/Land entfernt.
   - Load-more-Fortschritt via transform: scaleX (DS: nur
     transform/opacity animieren)
   - Hook-Namespace data-snzr-* (Root bleibt data-snz-reviews):
     kein generisches data-snz-* mehr (Kollisions-Learning v1.4.5)
   - Modal: Fokus auf Schliessen-Button beim Oeffnen, Rueckgabe an
     den Ausloeser beim Schliessen, Escape nur wenn offen

   Unveraendert aus v1.4.6/v1.4.7: Request-Sequencing, GET-Retry
   mit Backoff, fresh/stale Cache, Timeouts, Pagination-Commit erst
   nach Erfolg, Progressive Enhancement (.snz-js), safeUrl(),
   shortLabel(), Review-POST ohne Auto-Retry, JSON-LD.
   API-Host bleibt api.reviews.co.uk (laut OpenAPI offizieller
   zweiter Server neben api.reviews.io).
   ============================================================ */
(function () {
  'use strict';

  var API_BASE = 'https://api.reviews.co.uk';
  var FRESH_CACHE_TTL = 10 * 60 * 1000;
  var STALE_CACHE_TTL = 24 * 60 * 60 * 1000;
  var FETCH_TIMEOUT = 9000;
  var SUBMIT_TIMEOUT = 12000;
  var VOTE_TIMEOUT = 8000;
  var RETRY_DELAYS = [0, 500, 1500];
  var RETRY_JITTER = 250;
  var COUNT_BUDGET = 4000;     /* max. Wartezeit Polarisierungs-Zaehlung */
  var POLAR_MID_MAX = 0.5;     /* Mitte unter 50 % ... */
  var POLAR_EDGE_MIN = 0.2;    /* ... und beide Extreme mind. 20 % */

  var LOCALE = 'de-DE';  /* Zahlen/Datum, wird in init() aus data-locale gesetzt */

  /* REIHENFOLGE ZAEHLT: 'wirkungsdauer' vor 'wirkung' (Nikotinwirkung) */
  var LABEL_SHORT = [
    { re: /geschmack|taste/i,            key: 'taste' },
    { re: /wirkungsdauer|duration/i,     key: 'duration' },
    { re: /nikotin|nicotine|wirkung|st(\u00e4|a)rke|strength/i, key: 'nicotine' }
  ];
  function attrKey(label) {
    var s = String(label == null ? '' : label);
    for (var i = 0; i < LABEL_SHORT.length; i++) {
      if (LABEL_SHORT[i].re.test(s)) return LABEL_SHORT[i].key;
    }
    return null;
  }
  function shortLabel(label, txt) {
    var s = String(label == null ? '' : label).trim();
    if (!s) return s;
    var key = attrKey(s);
    if (key) return txt['attr_' + key];
    var stripped = s
      .replace(/^wie\s+(beurteilst\s+du|bewertest\s+du|ist|war)\s+(die|der|das|den)?\s*/i, '')
      .replace(/\s+(des|der)\s+produkts?\s*\??\s*$/i, '')
      .replace(/^(how\s+do\s+you\s+rate|what\s+is|how\s+is)\s+(the\s+)?/i, '')
      .replace(/\?\s*$/, '')
      .trim();
    if (!stripped) return s;
    return stripped.charAt(0).toUpperCase() + stripped.slice(1);
  }

  /* ---------- Utilities (pure, testbar) ---------- */

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function fmtNum(f, digits) {
    try {
      return new Intl.NumberFormat(LOCALE, { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(f);
    } catch (e) {
      return f.toFixed(digits);
    }
  }
  function fmtInt(n) {
    return fmtNum(parseInt(n, 10) || 0, 0);
  }
  function fmtScore(n) {
    var f = parseFloat(n);
    if (isNaN(f)) return '';
    return fmtNum(Math.round(f * 100) / 100, 2);
  }
  function fmtAvg(n) {
    var f = parseFloat(n);
    if (isNaN(f)) return '';
    return fmtNum(Math.round(f * 10) / 10, 1);
  }
  function pct(rating) {
    var f = parseFloat(rating);
    if (isNaN(f)) return 0;
    return Math.max(0, Math.min(100, (f / 5) * 100));
  }
  function capFirst(s) {
    s = String(s == null ? '' : s);
    return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
  }
  function formatDateLong(str) {
    if (!str) return '';
    var d = new Date(String(str).replace(' ', 'T'));
    if (isNaN(d.getTime())) return '';
    try {
      return d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) {
      return d.toLocaleDateString();
    }
  }
  function safeUrl(u) {
    var s = String(u == null ? '' : u).trim();
    if (!s) return '';
    if (/^https?:\/\//i.test(s)) return s;
    if (s.indexOf('//') === 0 && s.charAt(2) !== '/') return 'https:' + s;
    return '';
  }
  function sleep(ms) {
    return new Promise(function (res) { setTimeout(res, ms); });
  }
  function isRetryableStatus(status) {
    return status === 408 || status === 429 ||
           status === 500 || status === 502 || status === 503 || status === 504;
  }
  function supersededError() { var e = new Error('superseded'); e.snzSuperseded = true; return e; }
  function timeoutError() { var e = new Error('timeout'); e.snzTimeout = true; return e; }
  function httpError(status) { var e = new Error('HTTP ' + status); e.status = status; return e; }

  function buildFetchInit(opts, signal) {
    var init = {};
    if (opts.method) init.method = opts.method;
    if (opts.headers) init.headers = opts.headers;
    if (opts.body != null) init.body = opts.body;
    if (signal) init.signal = signal;
    return init;
  }

  function fetchWithTimeout(url, opts) {
    opts = opts || {};
    var timeoutMs = opts.timeout || FETCH_TIMEOUT;
    var external = opts.signal || null;
    if (external && external.aborted) return Promise.reject(supersededError());

    if (typeof AbortController !== 'undefined') {
      var ctrl = new AbortController();
      var timedOut = false;
      var timer = setTimeout(function () { timedOut = true; ctrl.abort(); }, timeoutMs);
      var onExternalAbort = function () { ctrl.abort(); };
      if (external && external.addEventListener) external.addEventListener('abort', onExternalAbort);
      var cleanup = function () {
        clearTimeout(timer);
        if (external && external.removeEventListener) external.removeEventListener('abort', onExternalAbort);
      };
      return fetch(url, buildFetchInit(opts, ctrl.signal)).then(function (res) {
        cleanup();
        return res;
      }, function (err) {
        cleanup();
        if (external && external.aborted) throw supersededError();
        if (timedOut) throw timeoutError();
        throw err;
      });
    }

    var raceTimer = null;
    var timeoutP = new Promise(function (_, rej) {
      raceTimer = setTimeout(function () { rej(timeoutError()); }, timeoutMs);
    });
    var fetchP = fetch(url, buildFetchInit(opts, null)).then(function (res) {
      clearTimeout(raceTimer);
      return res;
    }, function (err) {
      clearTimeout(raceTimer);
      if (external && external.aborted) throw supersededError();
      throw err;
    });
    return Promise.race([fetchP, timeoutP]);
  }

  /* GET-Retry — nie fuer den Review-POST verwenden */
  function fetchWithRetry(url, opts) {
    opts = opts || {};
    var external = opts.signal || null;
    var attempt = 0;
    function tryOnce() {
      if (external && external.aborted) return Promise.reject(supersededError());
      return fetchWithTimeout(url, opts).then(function (res) {
        if (res.ok) return res;
        throw httpError(res.status);
      }).catch(function (err) {
        if (err && err.snzSuperseded) throw err;
        var retryable = (err && typeof err.status === 'number') ? isRetryableStatus(err.status) : true;
        attempt++;
        if (!retryable || attempt >= RETRY_DELAYS.length) throw err;
        var delay = RETRY_DELAYS[attempt] + Math.random() * RETRY_JITTER;
        return sleep(delay).then(function () {
          if (external && external.aborted) throw supersededError();
          return tryOnce();
        });
      });
    }
    return tryOnce();
  }

  /* ---------- Cache (fresh/stale, sessionStorage optional) ---------- */

  function cacheKey(url) { return 'snzrev:' + url; }
  function getCachedResponse(url, maxAge) {
    try {
      var raw = sessionStorage.getItem(cacheKey(url));
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || typeof obj.t !== 'number') return null;
      if (Date.now() - obj.t > maxAge) return null;
      return obj.d;
    } catch (e) { return null; }
  }
  function setCachedResponse(url, data) {
    try {
      sessionStorage.setItem(cacheKey(url), JSON.stringify({ t: Date.now(), d: data }));
    } catch (e) {}
  }
  function fetchJSON(url, opts) {
    opts = opts || {};
    var fresh = getCachedResponse(url, FRESH_CACHE_TTL);
    if (fresh) return Promise.resolve(fresh);
    return fetchWithRetry(url, opts).then(function (res) {
      return res.json();
    }).then(function (json) {
      setCachedResponse(url, json);
      return json;
    }).catch(function (err) {
      if (err && err.snzSuperseded) throw err;
      var stale = getCachedResponse(url, STALE_CACHE_TTL);
      if (stale) {
        if (typeof console !== 'undefined' && console.warn) console.warn('[snz-reviews] Using stale cache', url);
        return stale;
      }
      throw err;
    });
  }
  /* Promise mit Zeitbudget: nach ms wird mit null aufgeloest */
  function withBudget(p, ms) {
    return Promise.race([
      p.catch(function () { return null; }),
      sleep(ms).then(function () { return null; })
    ]);
  }

  /* ---------- Daten-Logik (pure, testbar) ---------- */

  function filterExactRating(list, star) {
    if (!star) return list;
    return list.filter(function (r) { return Math.round(r.rating) === star; });
  }
  function pct45(dist) {
    var sum = 0, c45 = 0;
    (dist || []).forEach(function (row) {
      sum += row.count;
      if (row.stars >= 4) c45 += row.count;
    });
    if (!sum) return null;
    return Math.round((c45 / sum) * 100);
  }

  function buildFormAttrs(json) {
    var out = [];
    var f = json && json.filters && Array.isArray(json.filters.review_attributes)
      ? json.filters.review_attributes : [];
    f.forEach(function (a) {
      if (a.id == null || !Array.isArray(a.values) || !a.values.length) return;
      var opts = a.values.map(function (b, i) {
        var vals = b.values || [];
        if (!vals.length) return null;
        var v;
        if (i === 0) v = Math.min.apply(null, vals);
        else if (i === a.values.length - 1) v = Math.max.apply(null, vals);
        else v = vals[Math.floor(vals.length / 2)];
        return { label: b.label, value: v };
      }).filter(Boolean);
      if (opts.length) out.push({ id: a.id, label: a.label || '', options: opts });
    });
    if (out.length) return out;
    var st = json && json.stats && Array.isArray(json.stats.attributes) ? json.stats.attributes : [];
    st.forEach(function (a) {
      if (a.id == null || !Array.isArray(a.options) || a.options.length !== 3) return;
      out.push({ id: a.id, label: a.question || a.label || '', options: [
        { label: a.options[0], value: 1 },
        { label: a.options[1], value: 3 },
        { label: a.options[2], value: 5 }
      ]});
    });
    return out;
  }

  function buildSubmitParams(d) {
    var p = [
      ['store', d.store], ['sku', d.sku],
      ['name', d.name], ['email', d.email],
      ['review', d.review], ['rating', String(d.rating)]
    ];
    if (d.title) p.push(['title', d.title]);
    (d.attrs || []).forEach(function (a) {
      p.push(['additional_rating[' + a.id + ']', String(a.value)]);
    });
    return p.map(function (kv) {
      return encodeURIComponent(kv[0]) + '=' + encodeURIComponent(kv[1]);
    }).join('&');
  }

  /* 3-Stufen-Bucket einer centered-range-Skala: 1-2 / 3 / 4-5 */
  function bucketIndex(value) {
    var r = Math.round(parseFloat(value));
    if (isNaN(r)) return -1;
    if (r <= 2) return 0;
    if (r === 3) return 1;
    return 2;
  }
  function bucketWord(value, options) {
    if (!Array.isArray(options) || options.length !== 3) return null;
    var i = bucketIndex(value);
    return i === -1 ? null : options[i];
  }

  /* Position des Durchschnitts auf der 1–5-Skala in Prozent */
  function scalePos(avg) {
    var f = parseFloat(avg);
    if (isNaN(f)) return null;
    return Math.max(0, Math.min(100, ((f - 1) / 4) * 100));
  }

  /* Filter-Bucket eines Attributs (fuer Labels + Zaehl-Werte) */
  function findFilterAttr(entry, filters) {
    var attrs = filters && filters.review_attributes;
    if (!Array.isArray(attrs)) return null;
    for (var i = 0; i < attrs.length; i++) {
      var a = attrs[i];
      if (entry.id != null && String(a.id) === String(entry.id)) return a;
    }
    for (var j = 0; j < attrs.length; j++) {
      if ((attrs[j].label || '').toLowerCase() === String(entry.label || '').toLowerCase()) return attrs[j];
    }
    return null;
  }

  /* Drei Stufen-Labels: stats.options, sonst Filter-Buckets */
  function stopLabels(entry, filters) {
    if (Array.isArray(entry.options) && entry.options.length === 3) return entry.options.slice();
    var fa = findFilterAttr(entry, filters);
    if (fa && Array.isArray(fa.values) && fa.values.length === 3) {
      return fa.values.map(function (b) { return b.label; });
    }
    return null;
  }

  /* Zaehl-Werte der beiden Extreme (Filter-Buckets, Fallback 1,2 / 4,5) */
  function edgeValues(entry, filters) {
    var fa = findFilterAttr(entry, filters);
    if (fa && Array.isArray(fa.values) && fa.values.length === 3 &&
        (fa.values[0].values || []).length && (fa.values[2].values || []).length) {
      return [fa.values[0].values.join(','), fa.values[2].values.join(',')];
    }
    return ['1,2', '4,5'];
  }

  /* Mittig-optimal? Explizite IDs (Section-Setting) gewinnen,
     sonst Keyword-Erkennung ueber das Kurzlabel */
  function isCentered(entry, centeredIds) {
    if (centeredIds && centeredIds.length) return centeredIds.indexOf(String(entry.id)) !== -1;
    return attrKey(entry.label) === 'nicotine';
  }

  /* Anteile aus Zaehlung. null = nicht plausibel (Filter ignoriert) */
  function splitShares(total, low, high) {
    total = parseInt(total, 10) || 0;
    low = parseInt(low, 10);
    high = parseInt(high, 10);
    if (!total || isNaN(low) || isNaN(high) || low < 0 || high < 0) return null;
    if (low + high > total) return null;
    return [low / total, (total - low - high) / total, high / total];
  }
  function isPolarized(shares) {
    return !!shares && shares[1] < POLAR_MID_MAX &&
      shares[0] >= POLAR_EDGE_MIN && shares[2] >= POLAR_EDGE_MIN;
  }
  /* Ganzzahlige Prozente mit Summe 100 (Largest Remainder) */
  function roundShares(shares) {
    var raw = shares.map(function (s) { return s * 100; });
    var out = raw.map(Math.floor);
    var rest = 100 - out.reduce(function (a, b) { return a + b; }, 0);
    var order = raw.map(function (v, i) { return { i: i, r: v - Math.floor(v) }; })
      .sort(function (a, b) { return b.r - a.r; });
    for (var k = 0; k < rest && k < order.length; k++) out[order[k].i]++;
    return out;
  }

  /* Modell einer Hero-Skala */
  function buildAttrModel(entry, filters, centeredIds, txt) {
    var labels = stopLabels(entry, filters);
    var pos = scalePos(entry.average);
    if (!labels || pos == null) return null;
    var near = bucketIndex(entry.average);
    return {
      id: entry.id,
      label: shortLabel(entry.label, txt),
      labels: labels,
      pos: pos,
      near: near,
      count: entry.count,
      centered: isCentered(entry, centeredIds),
      edges: edgeValues(entry, filters)
    };
  }
  /* Braucht die Skala die Polarisierungs-Zaehlung? */
  function needsCount(m) {
    return !!m && m.centered && m.near === 1 && m.id != null && m.count > 0;
  }

  /* ---------- Normalisierung ---------- */

  function pickList(json) {
    if (!json) return [];
    if (Array.isArray(json.reviews)) return json.reviews;
    if (json.reviews && Array.isArray(json.reviews.data)) return json.reviews.data;
    if (Array.isArray(json.data)) return json.data;
    return [];
  }
  function pickTotal(json) {
    if (!json) return 0;
    if (json.review_count != null) return parseInt(json.review_count, 10) || 0;
    if (json.reviews && !Array.isArray(json.reviews) && json.reviews.total != null) return parseInt(json.reviews.total, 10) || 0;
    if (json.total != null) return parseInt(json.total, 10) || 0;
    return 0;
  }
  function pickResults(json) {
    if (!json) return 0;
    if (json.results_count != null) return parseInt(json.results_count, 10) || 0;
    return pickTotal(json);
  }
  function pickStats(json) {
    if (!json) return null;
    if (json.average_rating != null) return { average: parseFloat(json.average_rating), count: pickTotal(json) };
    var s = json.stats || null;
    if (s && (s.average != null || s.rating != null)) {
      var avg = s.average != null ? s.average : s.rating;
      return { average: parseFloat(avg), count: parseInt(s.count != null ? s.count : s.total, 10) || 0 };
    }
    return null;
  }
  function pickSubratings(json) {
    if (json && json.stats && Array.isArray(json.stats.attributes)) {
      return json.stats.attributes.map(function (a) {
        return {
          id: a.id,
          label: a.question || a.label || '',
          average: parseFloat(a.average_rating != null ? a.average_rating : a.average),
          count: parseInt(a.count, 10) || 0,
          options: Array.isArray(a.options) ? a.options : null
        };
      }).filter(function (a) { return a.label && !isNaN(a.average); });
    }
    return [];
  }
  function pickDistribution(json) {
    var src = json && json.stats && json.stats.ratings;
    if (!src || typeof src !== 'object') return [];
    var total = 0, out = [];
    [5, 4, 3, 2, 1].forEach(function (star) {
      var c = parseInt(src[star], 10) || 0;
      total += c;
      out.push({ stars: star, count: c });
    });
    return total ? out : [];
  }
  function buildAttrMap(json) {
    var map = {};
    if (json && json.stats && Array.isArray(json.stats.attributes)) {
      json.stats.attributes.forEach(function (a) {
        if (a.id != null && (a.question || a.label)) map[a.id] = a.question || a.label;
      });
    }
    if (json && json.filters && Array.isArray(json.filters.review_attributes)) {
      json.filters.review_attributes.forEach(function (a) {
        if (a.id != null && a.label && !map[a.id]) map[a.id] = a.label;
      });
    }
    return map;
  }
  function valueWord(entry, filters) {
    var w = bucketWord(entry.average, entry.options);
    if (w) return w;
    var rounded = Math.round(entry.average);
    var fa = findFilterAttr(entry, filters);
    if (fa && Array.isArray(fa.values)) {
      for (var j = 0; j < fa.values.length; j++) {
        var vals = fa.values[j].values || [];
        if (vals.indexOf(rounded) !== -1) return fa.values[j].label;
      }
    }
    return fmtScore(entry.average) + ' / 5';
  }

  function normalizeReview(r, attrMap, txt) {
    r = r || {};
    attrMap = attrMap || {};
    var author = '';
    if (r.author && r.author.name) {
      author = String(r.author.name).trim();
    } else if (r.reviewer) {
      var first = r.reviewer.first_name || '';
      var last = r.reviewer.last_name || '';
      author = ((first ? first.charAt(0).toUpperCase() + '.' : '') + ' ' + last).trim();
    }
    if (!author) author = txt.anonymous;

    var verified = false;
    if (r.verified != null) verified = !!r.verified;
    else if (r.reviewer) verified = r.reviewer.verified_buyer === 'yes' || r.reviewer.verified_buyer === true;

    var photos = [];
    var rawPhotos = r.photos || r.images || [];
    if (Array.isArray(rawPhotos)) {
      rawPhotos.forEach(function (p) {
        var url = typeof p === 'string' ? p : (p && (p.url || p.image_url || p.original || p.thumbnail));
        var thumb = typeof p === 'string' ? p : (p && (p.thumbnail || p.url || p.image_url || p.original));
        var su = safeUrl(url);
        var st = safeUrl(thumb || url);
        if (su) photos.push({ url: su, thumb: st || su });
      });
    }

    var attrs = [];
    var rawAttrs = r.attributes || r.ratings || r.review_attributes || [];
    if (Array.isArray(rawAttrs)) {
      rawAttrs.forEach(function (a) {
        var id = a.attribute_id != null ? a.attribute_id : (a.id != null ? a.id : null);
        var label = (id != null && attrMap[id]) || a.question || a.name || a.label || '';
        var val = parseFloat(a.value != null ? a.value : a.rating);
        if (label && !isNaN(val)) {
          attrs.push({ id: id, label: label, rating: val, word: bucketWord(val, a.options) });
        }
      });
    }

    return {
      id: r.id || r.product_review_id || r.store_review_id || r.review_id || null,
      rating: parseFloat(r.rating) || 0,
      title: r.title || r.heading || '',
      body: r.comments || r.review || r.body || '',
      author: author,
      verified: verified,
      date: formatDateLong(r.date_created || r.date),
      votes: parseInt(r.helpful_count != null ? r.helpful_count : (r.votes != null ? r.votes : r.helpful), 10) || 0,
      photos: photos,
      attrs: attrs
    };
  }

  /* ---------- Renderer (pure, testbar) ---------- */

  var CHECK_SVG = '<svg viewBox="0 0 12 12" width="10" height="10" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m2 6.5 2.5 2.5 5.5-6"/></svg>';

  function renderStars(rating, small, txt) {
    return '<span class="snz-stars' + (small ? ' snz-stars--sm' : '') + '" role="img" aria-label="' +
      esc(txt.stars_aria.replace('[rating]', fmtAvg(rating))) + '"><i style="width:' + pct(rating).toFixed(0) + '%"></i></span>';
  }

  /* Hero-Skala. mode: 'ready' | 'polar' | 'plain' (Wort ohne Nadel)
     shares nur bei 'polar' (gerundete Prozente) */
  function renderHeroAttr(m, mode, txt, shares) {
    txt = txt || {};
    var polar = mode === 'polar';
    var word = polar ? (txt.polar || 'Uneinheitlich') : capFirst(m.labels[m.near]);
    var aria = m.label + ': ' + (polar
      ? (txt.polar || 'Uneinheitlich') + ', ' + m.labels.map(function (l, i) { return l + ' ' + shares[i] + ' %'; }).join(', ')
      : m.labels[m.near]);
    var mark = '';
    if (!m.centered) {
      mark = '<i class="snz-trk__fill" style="width:' + m.pos.toFixed(1) + '%"></i>';
    } else if (mode === 'ready') {
      mark = '<i class="snz-trk__ndl" style="left:' + m.pos.toFixed(1) + '%"></i>';
    }
    var stops = m.labels.map(function (l, i) {
      var on = !polar && i === m.near;
      return '<span' + (on ? ' class="on"' : '') + '>' + esc(l) +
        (polar ? '<b>' + shares[i] + '\u00a0%</b>' : '') + '</span>';
    }).join('');
    return '<div class="snz-att" role="img" aria-label="' + esc(aria) + '">' +
      '<div class="snz-att__h"><div class="snz-att__lbl">' + esc(m.label) + '</div>' +
      '<p class="snz-att__w">' + esc(word) + '</p></div>' +
      '<div class="snz-trk" aria-hidden="true">' + mark + '</div>' +
      '<div class="snz-stops" aria-hidden="true">' + stops + '</div>' +
      '</div>';
  }
  function renderHeroSkel() {
    return '<div class="snz-att snz-att--skel" aria-hidden="true">' +
      '<span class="snz-skel snz-skel--lbl"></span><span class="snz-skel snz-skel--word"></span>' +
      '<span class="snz-skel snz-skel--trk"></span></div>';
  }

  /* Filter-Chips: Alle / 5–1 Sterne (Anzahl aus stats.ratings) / Mit Fotos */
  function renderChips(dist, total, txt, active) {
    txt = txt || {};
    active = active == null ? 'all' : active;
    function chip(key, label, count, disabled) {
      var on = String(active) === String(key);
      return '<button type="button" class="snz-chip' + (on ? ' is-on' : '') + '" data-snzr-f="' + key + '"' +
        ' aria-pressed="' + (on ? 'true' : 'false') + '"' + (disabled ? ' disabled' : '') + '>' +
        esc(label) + (count != null ? '<span>' + fmtInt(count) + '</span>' : '') + '</button>';
    }
    var html = chip('all', txt.all || 'Alle', total, false);
    (dist || []).forEach(function (row) {
      html += chip(row.stars, row.stars + ' \u2605', row.count, !row.count);
    });
    html += chip('media', txt.photos || 'Mit Fotos', null, false);
    return html;
  }

  /* Feed-Card v2.0.0 */
  function renderReview(r, filters, txt) {
    txt = txt || {};
    var html = '<article class="snz-item"' + (r.id ? ' data-review-id="' + esc(r.id) + '"' : '') + '>';
    html += '<div class="snz-item__top">' + renderStars(r.rating, true, txt);
    if (r.verified) html += '<span class="snz-vb">' + CHECK_SVG + esc(txt.verified || 'Verifizierter Kauf') + '</span>';
    html += '</div>';
    if (r.title) html += '<h3 class="snz-item__title">' + esc(r.title) + '</h3>';
    html += '<div class="snz-item__meta"><b>' + esc(r.author) + '</b>' + (r.date ? ' \u00b7 ' + esc(r.date) : '') + '</div>';
    if (r.body) html += '<p class="snz-item__txt">' + esc(r.body) + '</p>';
    if (r.attrs.length) {
      html += '<div class="snz-item__attrs">';
      r.attrs.forEach(function (a) {
        var val = a.word || valueWord({ id: a.id, label: a.label, average: a.rating, options: null }, filters);
        html += '<span>' + esc(shortLabel(a.label, txt)) + ' <b>' + esc(val) + '</b></span>';
      });
      html += '</div>';
    }
    if (r.photos.length) {
      html += '<div class="snz-item__media">';
      r.photos.slice(0, 4).forEach(function (p) {
        html += '<a href="' + esc(p.url) + '" target="_blank" rel="noopener">' +
          '<img src="' + esc(p.thumb) + '" alt="' + esc(txt.photo_alt) + '" loading="lazy" width="64" height="64"></a>';
      });
      html += '</div>';
    }
    if (r.id) {
      html += '<div class="snz-item__foot"><button type="button" class="snz-help" data-snzr-vote="' + esc(r.id) + '">' +
        esc(txt.helpful) + (r.votes ? ' (' + fmtInt(r.votes) + ')' : '') + '</button></div>';
    }
    html += '</article>';
    return html;
  }

  /* ---------- DOM / App ---------- */

  function init(root) {
    if (!root || root.dataset.snzInit === '1') return;
    root.dataset.snzInit = '1';
    root.dataset.snzJs = '2.1.0';
    root.classList.add('snz-js');

    var ds = root.dataset;
    if (ds.locale) LOCALE = ds.locale;
    var cfg = {
      store: ds.store,
      lang: ds.lang || '',
      sku: ds.sku || '',
      perPage: parseInt(ds.perPage, 10) || 5,
      centeredIds: String(ds.centered || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean)
    };
    function q(sel) { return root.querySelector(sel); }
    var txt = JSON.parse(q('[data-snzr-i18n]').textContent);
    var els = {
      headcount: q('[data-snzr-headcount]'),
      score: q('[data-snzr-score]'),
      stars: q('[data-snzr-stars]'),
      scoremeta: q('[data-snzr-scoremeta]'),
      attrs: q('[data-snzr-attrs]'),
      chips: q('[data-snzr-chips]'),
      list: q('[data-snzr-list]'),
      empty: q('[data-snzr-empty]'),
      feederr: q('[data-snzr-feederr]'),
      morewrap: q('[data-snzr-morewrap]'),
      more: q('[data-snzr-more]'),
      count: q('[data-snzr-count]'),
      progress: q('[data-snzr-progress]'),
      sortSel: q('[data-snzr-sortsel]')
    };

    var distCounts = {};
    var filtersCache = null;
    var attrsMeta = [];
    var state = { page: 1, sort: 'date_desc', f: 'all', total: 0, shown: 0,
                  loadingMore: false, appendReqId: 0, statsDone: false };
    var requestSeq = 0;
    var activeController = null;

    function baseParams() {
      var p = [
        'store=' + encodeURIComponent(cfg.store),
        'type=product_review',
        'sku=' + encodeURIComponent(cfg.sku)
      ];
      if (cfg.lang) p.push('lang=' + encodeURIComponent(cfg.lang));
      return p;
    }
    function apiUrl(snap) {
      var star = typeof snap.f === 'number' ? snap.f : 0;
      var p = baseParams().concat([
        'page=' + snap.page,
        'per_page=' + cfg.perPage,
        'sort=' + (star ? 'lowest_rating' : snap.sort),
        'include_subrating_breakdown=true'
      ]);
      if (snap.f === 'media') p.push('with=media');
      if (star) p.push('minRating=' + star);
      return API_BASE + '/reviews?' + p.join('&');
    }
    /* Zaehl-URL fuer ein Attribut-Bucket (nur results_count wird gelesen) */
    function countUrl(attrId, values) {
      var p = baseParams().concat([
        'page=1', 'per_page=1',
        encodeURIComponent('product_question[' + attrId + ']') + '=' + encodeURIComponent(values)
      ]);
      return API_BASE + '/reviews?' + p.join('&');
    }

    function fail(err) {
      if (typeof console !== 'undefined' && console.warn) console.warn('[snz-reviews]', err);
      root.classList.add('snz-fail');
    }
    function showFeedError(msg) {
      if (!els.feederr) return;
      els.feederr.textContent = msg;
      els.feederr.classList.remove('is-hidden');
    }
    function hideFeedError() {
      if (!els.feederr) return;
      els.feederr.classList.add('is-hidden');
      els.feederr.textContent = '';
    }

    /* Hero-Skalen inkl. Polarisierungs-Zaehlung */
    function renderHero(json) {
      if (!els.attrs) return;
      var models = pickSubratings(json)
        .map(function (s) { return buildAttrModel(s, json.filters, cfg.centeredIds, txt); })
        .filter(Boolean);
      if (!models.length) {
        els.attrs.classList.add('is-hidden');
        return;
      }
      els.attrs.innerHTML = models.map(function (m, i) {
        return '<div data-snzr-att="' + i + '">' + (needsCount(m) ? renderHeroSkel() : renderHeroAttr(m, 'ready', txt)) + '</div>';
      }).join('');

      models.forEach(function (m, i) {
        if (!needsCount(m)) return;
        var slot = els.attrs.querySelector('[data-snzr-att="' + i + '"]');
        var counts = Promise.all([
          fetchJSON(countUrl(m.id, m.edges[0]), { timeout: FETCH_TIMEOUT }),
          fetchJSON(countUrl(m.id, m.edges[1]), { timeout: FETCH_TIMEOUT })
        ]);
        withBudget(counts, COUNT_BUDGET).then(function (res) {
          if (!slot) return;
          var shares = res ? splitShares(m.count, pickResults(res[0]), pickResults(res[1])) : null;
          if (!shares) {
            slot.innerHTML = renderHeroAttr(m, 'plain', txt);
          } else if (isPolarized(shares)) {
            slot.innerHTML = renderHeroAttr(m, 'polar', txt, roundShares(shares));
          } else {
            slot.innerHTML = renderHeroAttr(m, 'ready', txt);
          }
        });
      });
    }

    function renderStats(json) {
      if (state.statsDone) return;
      var stats = pickStats(json);
      var total = pickTotal(json);
      var dist = pickDistribution(json);

      if (stats && total > 0) {
        if (els.score) els.score.textContent = fmtAvg(stats.average);
        if (els.stars) els.stars.style.width = pct(stats.average).toFixed(0) + '%';
        if (els.headcount) {
          var htpl = els.headcount.dataset.template || txt.count;
          els.headcount.textContent = htpl.replace('[count]', fmtInt(total));
        }
        if (els.scoremeta) {
          var share = pct45(dist);
          var ptpl = els.scoremeta.dataset.pctTemplate || '';
          els.scoremeta.textContent = (share != null && ptpl.indexOf('[pct]') !== -1)
            ? ptpl.replace('[pct]', String(share))
            : txt.count.replace('[count]', fmtInt(total));
        }
      }

      dist.forEach(function (row) { distCounts[row.stars] = row.count; });
      if (els.chips) els.chips.innerHTML = renderChips(dist, total, txt, state.f);

      attrsMeta = buildFormAttrs(json);
      renderHero(json);

      if (stats && total > 0 && ds.productName) {
        var ld = {
          '@context': 'https://schema.org',
          '@type': 'Product',
          'name': ds.productName,
          'url': ds.productUrl || undefined,
          'aggregateRating': {
            '@type': 'AggregateRating',
            'ratingValue': String(Math.round(stats.average * 100) / 100),
            'reviewCount': String(total),
            'bestRating': '5'
          }
        };
        var s = document.createElement('script');
        s.type = 'application/ld+json';
        s.textContent = JSON.stringify(ld);
        root.appendChild(s);
      }
      state.statsDone = true;
    }

    function updateMore(hasMore) {
      if (!els.morewrap) return;
      els.morewrap.classList.toggle('is-hidden', !hasMore && !state.shown);
      if (els.more) els.more.classList.toggle('is-hidden', !hasMore);
      if (els.count) {
        els.count.textContent = state.total
          ? txt.progress.replace('[shown]', fmtInt(Math.min(state.shown, state.total))).replace('[total]', fmtInt(state.total))
          : '';
      }
      if (els.progress) {
        var r = state.total ? Math.min(1, state.shown / state.total) : 0;
        els.progress.style.transform = 'scaleX(' + r.toFixed(4) + ')';
      }
    }
    function resetAppendUi(reqId) {
      if (state.appendReqId !== reqId) return;
      state.loadingMore = false;
      if (els.more) els.more.disabled = false;
    }

    function load(append) {
      if (append && state.loadingMore) return;
      var snap = { page: append ? state.page + 1 : 1, sort: state.sort, f: state.f, append: !!append };
      var pristine = snap.page === 1 && snap.f === 'all' && snap.sort === 'date_desc';

      requestSeq++;
      var reqId = requestSeq;
      if (activeController) { try { activeController.abort(); } catch (e) {} }
      var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      activeController = ctrl;
      hideFeedError();

      if (append) {
        state.loadingMore = true;
        state.appendReqId = reqId;
        if (els.more) els.more.disabled = true;
      } else if (els.list) {
        els.list.innerHTML =
          '<div class="snz-skel snz-skel--row"></div>' +
          '<div class="snz-skel snz-skel--row"></div>' +
          '<div class="snz-skel snz-skel--row"></div>';
        if (els.empty) els.empty.classList.add('is-hidden');
      }

      fetchJSON(apiUrl(snap), { signal: ctrl ? ctrl.signal : null, timeout: FETCH_TIMEOUT })
        .then(function (json) {
          if (reqId !== requestSeq) { if (snap.append) resetAppendUi(reqId); return; }
          if (snap.append) resetAppendUi(reqId);

          if (!snap.append && pristine && pickTotal(json) === 0 && !pickList(json).length) {
            root.classList.add('snz-zero-state');
            return;
          }
          root.classList.remove('snz-zero-state');

          renderStats(json);
          if (json && json.filters) filtersCache = json.filters;

          var attrMap = buildAttrMap(json);
          var star = typeof snap.f === 'number' ? snap.f : 0;
          var list = pickList(json).map(function (r) { return normalizeReview(r, attrMap, txt); });
          list = filterExactRating(list, star);
          state.total = pickResults(json);
          if (star && distCounts[star] != null) state.total = Math.min(state.total, distCounts[star]);

          var html = list.map(function (r) { return renderReview(r, filtersCache, txt); }).join('');
          if (snap.append) {
            els.list.insertAdjacentHTML('beforeend', html);
            state.shown += list.length;
            state.page = snap.page;
          } else {
            els.list.innerHTML = html;
            state.shown = list.length;
            state.page = 1;
          }
          if (!state.shown && els.empty) els.empty.classList.remove('is-hidden');
          updateMore(state.shown < state.total && list.length > 0);
        })
        .catch(function (err) {
          if (snap.append) resetAppendUi(reqId);
          if (err && err.snzSuperseded) return;
          if (reqId !== requestSeq) return;
          if (snap.append) {
            showFeedError(txt.more_error);
            return;
          }
          if (pristine) { fail(err); return; }
          if (els.list) els.list.innerHTML = '';
          state.shown = 0;
          showFeedError(txt.load_error);
          updateMore(false);
        });
    }

    /* Filter-Chips: single-select, aktiver Chip erneut = zurueck auf Alle */
    if (els.chips) {
      els.chips.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-snzr-f]');
        if (!btn || btn.disabled) return;
        var raw = btn.getAttribute('data-snzr-f');
        var key = (raw === 'all' || raw === 'media') ? raw : (parseInt(raw, 10) || 'all');
        state.f = (state.f === key && key !== 'all') ? 'all' : key;
        els.chips.querySelectorAll('[data-snzr-f]').forEach(function (b) {
          var on = b.getAttribute('data-snzr-f') === String(state.f);
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        load(false);
      });
    }

    if (els.sortSel) {
      els.sortSel.addEventListener('change', function () {
        state.sort = els.sortSel.value || 'date_desc';
        load(false);
      });
    }

    if (els.more) {
      els.more.addEventListener('click', function () { load(true); });
    }

    if (els.list) {
      els.list.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-snzr-vote]');
        if (!btn || btn.disabled) return;
        btn.disabled = true;
        var raw = btn.getAttribute('data-snzr-vote');
        var id = String(raw).replace(/[^\d]/g, '') || raw;
        fetchWithTimeout(API_BASE + '/product/vote?store=' + encodeURIComponent(cfg.store) +
              '&review=' + encodeURIComponent(id), { timeout: VOTE_TIMEOUT })
          .then(function (res) {
            if (res.ok) btn.textContent = txt.thanks;
            else btn.disabled = false;
          })
          .catch(function () { btn.disabled = false; });
      });
    }

    /* ---------- Bewertungsformular-Modal ---------- */
    (function initModal() {
      var modal = q('[data-snzr-modal]');
      if (!modal) return;
      var panel = modal.querySelector('.snz-modal__panel');
      var form = modal.querySelector('[data-snzr-form]');
      var attrsWrap = modal.querySelector('[data-snzr-form-attrs]');
      var starpick = modal.querySelector('[data-snzr-starpick]');
      var starword = modal.querySelector('[data-snzr-starword]');
      var formerr = modal.querySelector('[data-snzr-formerr]');
      var closeBtn = modal.querySelector('.snz-modal__close');
      var starWords = txt.star_words;
      var fstate = { stars: 0, attrs: {} };
      var submitting = false;
      var opener = null;

      function isOpen() { return modal.classList.contains('is-open'); }
      function open(trigger) {
        opener = trigger || null;
        modal.classList.remove('is-done');
        renderAttrs();
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.dataset.snzPrevOverflow = document.body.style.overflow || '';
        document.body.style.overflow = 'hidden';
        if (closeBtn) { try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); } }
      }
      function close() {
        if (!isOpen()) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = document.body.dataset.snzPrevOverflow || '';
        delete document.body.dataset.snzPrevOverflow;
        if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); } }
      }

      root.addEventListener('click', function (e) {
        var w = e.target.closest('[data-snzr-write]');
        if (w) { open(w); return; }
        if (e.target.closest('[data-snzr-mclose]')) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen()) close();
      });

      function renderAttrs() {
        if (!attrsWrap) return;
        if (!attrsMeta.length) { attrsWrap.innerHTML = ''; return; }
        if (attrsWrap.dataset.rendered === '1') return;
        attrsWrap.dataset.rendered = '1';
        attrsWrap.innerHTML = attrsMeta.map(function (a) {
          return '<div class="snz-f"><div class="snz-f__lbl">' + esc(a.label) +
            ' <em>' + esc(txt.optional) + '</em></div><div class="snz-segbtns" data-attr-id="' + esc(a.id) + '">' +
            a.options.map(function (o) {
              return '<button type="button" class="snz-segbtn" aria-pressed="false" data-v="' + esc(o.value) + '">' +
                esc(o.label) + '</button>';
            }).join('') + '</div></div>';
        }).join('');
      }

      if (starpick) {
        starpick.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          fstate.stars = parseInt(b.dataset.v, 10);
          starpick.querySelectorAll('button').forEach(function (x) {
            x.classList.toggle('on', parseInt(x.dataset.v, 10) <= fstate.stars);
          });
          if (starword) starword.textContent = starWords[fstate.stars - 1] || '';
          var f = modal.querySelector('[data-snzr-field="stars"]');
          if (f) f.classList.remove('has-error');
        });
      }

      modal.addEventListener('click', function (e) {
        var b = e.target.closest('.snz-segbtn'); if (!b) return;
        var g = b.closest('[data-attr-id]'); if (!g) return;
        var id = g.dataset.attrId;
        var was = b.classList.contains('on');
        g.querySelectorAll('.snz-segbtn').forEach(function (x) {
          x.classList.remove('on');
          x.setAttribute('aria-pressed', 'false');
        });
        if (!was) {
          b.classList.add('on');
          b.setAttribute('aria-pressed', 'true');
          fstate.attrs[id] = parseInt(b.dataset.v, 10);
        } else {
          delete fstate.attrs[id];
        }
      });

      /* Inline-Validierung: Fehler verschwindet, sobald das Feld gueltig ist */
      var validators = {
        text: function (v) { return v.trim().length >= 3; },
        name: function (v) { return v.trim().length >= 2; },
        email: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()); }
      };
      modal.addEventListener('input', function (e) {
        var f = e.target.closest('[data-snzr-field]');
        if (!f || !f.classList.contains('has-error')) return;
        var key = f.getAttribute('data-snzr-field');
        if (validators[key] && validators[key](e.target.value || '')) f.classList.remove('has-error');
      });

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (submitting) return;
          if (formerr) formerr.classList.remove('is-visible');
          var ok = true;
          function check(key, valid) {
            var f = modal.querySelector('[data-snzr-field="' + key + '"]');
            if (f) f.classList.toggle('has-error', !valid);
            if (!valid) ok = false;
          }
          function val(sel) { var el = modal.querySelector(sel); return el ? (el.value || '') : ''; }
          var title = val('[data-snzr-ftitle]');
          var text = val('[data-snzr-ftext]');
          var name = val('[data-snzr-fname]');
          var mail = val('[data-snzr-femail]');
          check('stars', fstate.stars > 0);
          check('text', validators.text(text));
          check('name', validators.name(name));
          check('email', validators.email(mail));
          if (!ok) {
            var first = modal.querySelector('.snz-f.has-error');
            if (first) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
            return;
          }
          var attrs = Object.keys(fstate.attrs).map(function (id) { return { id: id, value: fstate.attrs[id] }; });
          var body = buildSubmitParams({
            store: cfg.store,
            sku: ds.skuPrimary || (cfg.sku.split(';')[0] || ''),
            name: name.trim(), email: mail.trim(),
            review: text.trim(), rating: fstate.stars,
            title: title.trim(), attrs: attrs
          });
          var btn = form.querySelector('[type="submit"]');
          submitting = true;
          btn.classList.add('is-loading');
          function doneSubmit() { submitting = false; btn.classList.remove('is-loading'); }

          fetchWithTimeout(API_BASE + '/product/review/new', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body,
            timeout: SUBMIT_TIMEOUT
          }).then(function (res) {
            doneSubmit();
            if (res.ok) {
              modal.classList.add('is-done');
              if (panel) panel.scrollTop = 0;
              return;
            }
            if (formerr) {
              formerr.textContent = res.status === 429 ? txt.submit_429 : txt.submit_error;
              formerr.classList.add('is-visible');
            }
          }).catch(function (err) {
            doneSubmit();
            if (formerr) {
              formerr.textContent = (err && err.snzTimeout) ? txt.submit_timeout : txt.submit_offline;
              formerr.classList.add('is-visible');
            }
          });
        });
      }
    })();

    load(false);
  }

  function boot() {
    document.querySelectorAll('[data-snz-reviews]').forEach(init);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      esc: esc, fmtInt: fmtInt, fmtScore: fmtScore, fmtAvg: fmtAvg, pct: pct, capFirst: capFirst,
      formatDateLong: formatDateLong, safeUrl: safeUrl, sleep: sleep, isRetryableStatus: isRetryableStatus,
      getCachedResponse: getCachedResponse, setCachedResponse: setCachedResponse,
      fetchWithTimeout: fetchWithTimeout, fetchWithRetry: fetchWithRetry, fetchJSON: fetchJSON, withBudget: withBudget,
      filterExactRating: filterExactRating, pct45: pct45, buildFormAttrs: buildFormAttrs,
      buildSubmitParams: buildSubmitParams, bucketIndex: bucketIndex, bucketWord: bucketWord,
      scalePos: scalePos, findFilterAttr: findFilterAttr, stopLabels: stopLabels, edgeValues: edgeValues,
      isCentered: isCentered, splitShares: splitShares, isPolarized: isPolarized, roundShares: roundShares,
      buildAttrModel: buildAttrModel, needsCount: needsCount,
      pickList: pickList, pickTotal: pickTotal, pickResults: pickResults, pickStats: pickStats,
      pickSubratings: pickSubratings, pickDistribution: pickDistribution, buildAttrMap: buildAttrMap,
      valueWord: valueWord, normalizeReview: normalizeReview, shortLabel: shortLabel, attrKey: attrKey,
      renderStars: renderStars, renderHeroAttr: renderHeroAttr, renderHeroSkel: renderHeroSkel,
      renderChips: renderChips, renderReview: renderReview
    };
  }
})();